import { __decorate, __metadata } from "tslib";
import { lazyAppContextConsumer } from '@1inch-community/core/lazy';
import { ChainId } from '@1inch-community/models';
import { chainViewConfig } from '@1inch-community/sdk/chain';
import '@1inch-community/ui-components/icon';
import '@1inch-community/ui-components/loaders';
import { Task } from '@lit/task';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import { tokenIconStyle } from './token-icon.style';
let TokenIconElement = class TokenIconElement extends LitElement {
    constructor() {
        super(...arguments);
        this.size = 24;
        this.hideChainIcon = false;
        this.applicationContext = lazyAppContextConsumer(this);
        this.task = new Task(this, {
            task: async ([symbol, address, chainId]) => {
                const img = await this.iconLoader(chainId, symbol, address);
                img.width = this.size;
                img.height = this.size;
                img.ondragstart = () => false;
                return img;
            },
            args: () => [this.symbol, this.address, this.chainId],
        });
    }
    static { this.tagName = 'inch-token-icon'; }
    static { this.styles = [tokenIconStyle]; }
    render() {
        return this.task.render({
            error: () => this.renderLoaderOrIcon(),
            pending: () => this.renderLoaderOrIcon(),
            complete: () => this.renderLoaderOrIcon(),
        });
    }
    updated() {
        this.style.width = `${this.size}px`;
        this.style.height = `${this.size}px`;
    }
    renderLoaderOrIcon() {
        let template;
        if (!this.task.value) {
            template = this.loaderTemplate(this.task.status === 1);
        }
        else {
            template = html `${this.task.value}`;
        }
        return appendChainIcon(template, this.hideChainIcon, this.size, this.chainId);
    }
    async iconLoader(chainId, symbol, address) {
        const result = await this.loadFromDatabase(chainId, symbol, address);
        if (result === null) {
            throw new Error('token icon not fount');
        }
        return result;
    }
    async loadFromDatabase(chainId, symbol, address) {
        const logoURL = [];
        if (chainId && address) {
            const url = await this.applicationContext.value.tokenStorage.getTokenLogoURL(chainId, address);
            if (url) {
                logoURL.push(url);
            }
        }
        if (logoURL.length === 0 && symbol) {
            const urls = await this.applicationContext.value.tokenStorage.getTokenLogoURLsBySymbol(symbol);
            if (urls) {
                logoURL.push(...new Set(urls));
            }
        }
        if (logoURL.length === 0) {
            return null;
        }
        const loader = (url) => new Promise((resolve) => {
            const img = new Image();
            img.onerror = () => resolve(null);
            img.onload = () => resolve(img);
            img.src = url;
        });
        for (const url of logoURL) {
            const img = await loader(url);
            if (img)
                return img;
        }
        return null;
    }
    loaderTemplate(showLoader) {
        const { size, symbol } = this;
        const style = {
            fontSize: `${size < 40 ? 13 : 16}px`,
        };
        return html `
      <inch-loader-spinner size="${size}" .showLoader="${showLoader}">
        <span style="${styleMap(style)}">${symbol?.slice(0, size < 40 ? 1 : 2) ?? ''}</span>
      </inch-loader-spinner>
    `;
    }
};
__decorate([
    property({ type: String, attribute: true }),
    __metadata("design:type", String)
], TokenIconElement.prototype, "symbol", void 0);
__decorate([
    property({ type: String, attribute: true }),
    __metadata("design:type", String)
], TokenIconElement.prototype, "address", void 0);
__decorate([
    property({ type: Number, attribute: true }),
    __metadata("design:type", Number)
], TokenIconElement.prototype, "chainId", void 0);
__decorate([
    property({ type: Number, attribute: true }),
    __metadata("design:type", Object)
], TokenIconElement.prototype, "size", void 0);
__decorate([
    property({ type: Boolean, attribute: true }),
    __metadata("design:type", Object)
], TokenIconElement.prototype, "hideChainIcon", void 0);
TokenIconElement = __decorate([
    customElement(TokenIconElement.tagName)
], TokenIconElement);
export { TokenIconElement };
function appendChainIcon(view, hideChainIcon, size, chainId) {
    if (!chainId || hideChainIcon)
        return view;
    const chainSize = size / 2.5;
    const offset = 2;
    const maskImageSize = chainSize / 2 + offset;
    const maskImageX = size - chainSize + maskImageSize - offset;
    const maskImageY = size - chainSize + maskImageSize + offset;
    const style = {
        '--mask-image-size': `${maskImageSize}px`,
        '--mask-image-x': `${maskImageX}px`,
        '--mask-image-y': `${maskImageY}px`,
    };
    return html `
    <div class="wrap-chain" style="${styleMap(style)}">
      ${view}
      <inch-icon
        class="chain-view"
        width="${chainSize}"
        height="${chainSize}"
        icon="${chainViewConfig[chainId].iconName}"
      ></inch-icon>
    </div>
  `;
}
//# sourceMappingURL=token-icon.element.js.map